export default function dynamicComponent(state = {}, action) {
  if (action.type === 'SET_COMPONENT_IN_STORE') {
    let { component: { name = '', instance = '' } = {} } = action;
    const nextState = { ...state };
    if (name && instance) {
      let componentName = name.trim().toLowerCase();
      nextState[componentName] = instance;
      return nextState;
    }
    return nextState;
  }
  return state;
}
